import { gql } from '@apollo/client';

export const LIST_GASTRONOMIC_GUIDE=gql`
    query listEvents($first:Int, $page:Int){
        allGastronomicGuide(first:$first, page:$page){
            data{
                id,
                nombre,
                logo_path_url,
                url,
                is_passaporte_canirac,
                orden,
                promocion,
                sucursales{
                    id,
                    nombre,
                    direccion,
                    
                    telefono,
                    horario
                }

                created_at,
            }
        }
    }
`;



export const GENERATE_GASTRONOMIC_GUIDE_PDF=gql`
    mutation($profile_uuid:ID!, $gastronomic_guide_id:Int!){
        generateGastronomicGuidePdf(profile_uuid:$profile_uuid gastronomic_guide_id:$gastronomic_guide_id){
            url
        }
    }
`;


export const MUTATION_GASTRONOMIC_GUIDE_LIST_TICKET_BY_CODE_SCAN=gql`
    mutation($code:ID!, $password:String!){
        getGastronomicGuideListTicketByCodeScan(code:$code password:$password){
            id,
            last_scan,
            first_scan,
            gastronomicGuide{
                id,
                nombre,
                logo_path_url
            }
        }
    }
`;

export const QUERY_LIST_GASTRONOMIC_GUIDE_VISITS=gql`
    query($profile_uuid:ID!){
        listGastronomicGuideVisits(profile_uuid:$profile_uuid){
            gastronomic_guide_id,
            total
        }
    }
`;